import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'diferenciaEntreFechas'
})
export class diferenciaEntreFechas implements PipeTransform {
  transform(cuota: any): any {

    const fechaUltimoPago: string = cuota.ultimo_pago;
    const fechaVencimientoCuota: string = cuota.fecha_vence;
    let diffInHours: number;
    let diferenciaEnDias: string;

    if ( fechaUltimoPago ) {

      const diffInMs: number = Date.parse(fechaUltimoPago) - Date.parse(fechaVencimientoCuota);
      diffInHours = diffInMs / 1000 / 60 / 60;
      diferenciaEnDias = String(Math.round( diffInHours >= 1 ? (diffInHours / 24) : 0 ));
    } else {
      diferenciaEnDias = '-';
    }

    return diferenciaEnDias;
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/pipes/diferenciaEntreFechas.pipe.ts